import React, {FC} from 'react'
import {DvTaskEstimation, TASK_ESTIMATION_VALUES} from '@dv5/domain'
import './EstimationPicker.less'

export interface EstimationPickerProps {
    value?: DvTaskEstimation
    onSelect: (value: DvTaskEstimation | undefined) => void
    allowClear?: boolean
    className?: string
}

export const EstimationPicker: FC<EstimationPickerProps> = ({
                                                                value,
                                                                onSelect,
                                                                allowClear = false,
                                                                className,
                                                            }) => {
    const rootClass = `estimation-picker${className ? ` ${className}` : ''}`

    const stopPropagation = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault()
        event.stopPropagation()
    }

    return (
        <div className={rootClass}>
            <div className="estimation-picker__values">
                {TASK_ESTIMATION_VALUES.map(estimationValue => (
                    <button key={estimationValue}
                            type="button"
                            className={`estimation-picker__value${value === estimationValue ? ' active' : ''}`}
                            onMouseDown={stopPropagation}
                            onClick={event => {
                                stopPropagation(event)
                                onSelect(estimationValue)
                            }}
                    >
                        {estimationValue}
                    </button>
                ))}
            </div>
            {allowClear && value !== undefined && (
                <button type="button"
                        className="estimation-picker__clear"
                        onMouseDown={stopPropagation}
                        onClick={event => {
                            stopPropagation(event)
                            onSelect(undefined)
                        }}
                >
                    Clear
                </button>
            )}
        </div>
    )
}
